import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';

function Layout({ children }) {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center',
        alignItems: 'center', height: '100vh', gap: 16 }}>
        <div style={{ width: 50, height: 50, border: '5px solid #f3f3f3',
          borderTop: '5px solid #FF6B35', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        <p>Yüklənir...</p>
      </div>
    );
  }

  if (!admin) return <Navigate to="/login" replace />;

  return (
    <div className="sa-layout">
      <Sidebar />
      <div className="sa-main">
        <Header />
        <div className="sa-content">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
